import React from 'react';
import { MOCK_PROJECTS } from '../../mock';
import Badge from '../../components/common/Badge';

const statusVariant: Record<string, any> = {
  pending: 'warning', scheduled: 'info', in_progress: 'orange',
  completed: 'success', cancelled: 'danger', on_hold: 'warning',
};

const CustomerProjects: React.FC = () => (
  <div>
    <h2 style={{ fontWeight: 800, fontSize: '1.5rem', marginBottom: '1.5rem', color: 'var(--text-primary)' }}>My Projects</h2>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      {MOCK_PROJECTS.map(p => (
        <div key={p.id} className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem', flexWrap: 'wrap', gap: '0.5rem' }}>
            <div>
              <h3 style={{ fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.25rem' }}>{p.title}</h3>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', margin: 0 }}>{p.projectNumber} · {p.address}</p>
            </div>
            <Badge label={p.status.replace('_', ' ')} variant={statusVariant[p.status]} />
          </div>

          {p.progress > 0 && (
            <div style={{ marginBottom: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: '0.375rem' }}>
                <span>Progress</span><span>{p.progress}%</span>
              </div>
              <div style={{ background: 'var(--bg-secondary)', borderRadius: '9999px', height: '8px', overflow: 'hidden' }}>
                <div style={{ background: 'linear-gradient(90deg, #f97316, #ea580c)', height: '100%', width: `${p.progress}%`, borderRadius: '9999px' }} />
              </div>
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem' }}>
            {[
              { label: 'Start Date', value: p.startDate },
              { label: 'End Date', value: p.endDate || 'TBD' },
              { label: 'Budget', value: `$${p.budget.toLocaleString()}` },
              { label: 'Contractor', value: p.contractorName || 'TBD' },
            ].map(item => (
              <div key={item.label}>
                <p style={{ fontSize: '0.7rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 0.2rem' }}>{item.label}</p>
                <p style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: '0.875rem', margin: 0 }}>{item.value}</p>
              </div>
            ))}
          </div>

          {p.notes && (
            <div style={{ marginTop: '1rem', padding: '0.75rem', background: 'var(--bg-secondary)', borderRadius: '0.625rem', borderLeft: '3px solid #f97316' }}>
              <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', margin: 0, fontStyle: 'italic' }}>{p.notes}</p>
            </div>
          )}
        </div>
      ))}
    </div>
    <style>{`@media(max-width:640px){div[style*="repeat(auto-fit, minmax(150px, 1fr))"]{grid-template-columns:1fr 1fr!important}}`}</style>
  </div>
);

export default CustomerProjects;
